import { Routes } from '@angular/router';
import { RegistroComponent } from './registro/registro.component';

export const routes: Routes = [
  { path: '', component: RegistroComponent },
  { path: '**', redirectTo: '' }
];
